import { render, staticRenderFns } from "./explain-results-score-row.component.vue?vue&type=template&id=17bf2f42&scoped=true"
import script from "./explain-results-score-row.component.vue?vue&type=script&lang=ts"
export * from "./explain-results-score-row.component.vue?vue&type=script&lang=ts"
import style0 from "./explain-results-score-row.component.vue?vue&type=style&index=0&id=17bf2f42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bf2f42",
  null
  
)

export default component.exports